import { useTranslation } from "react-i18next";

import type { AdherenceRow } from "@/api/diagnostic";

import { ADHERENCE_BAR, ADHERENCE_COLORS, makeAdherenceStatusMeta } from "../diagnosticMeta";
import { StackedBar } from "../primitives/StackedBar";

/**
 * A barra verde, amarela e vermelha de uma linha do índice (RF-06 e RF-07).
 *
 * Desenha as contagens, e não os percentuais: a proporção é a mesma, e a
 * contagem não depende do arredondamento pelo maior resto.
 */
export function AdherenceBar({ row, height }: { row: AdherenceRow; height: string }) {
  const { t } = useTranslation();
  const labels = makeAdherenceStatusMeta(t);
  return (
    <StackedBar
      height={height}
      segments={ADHERENCE_COLORS.map((color) => ({
        key: color,
        label: labels[color],
        className: ADHERENCE_BAR[color],
        value: row[color].count,
      }))}
    />
  );
}
